import { useEffect, useState } from 'react'
import { Outlet, Link } from 'react-router-dom'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import { BsChevronDown, BsChevronUp } from 'react-icons/bs'
import { RiLayoutMasonryFill } from 'react-icons/ri'
import { FaRunning } from 'react-icons/fa'
import { GiGraduateCap } from 'react-icons/gi'
import { RiUserSmileLine } from 'react-icons/ri'
import { MdOutlineAssessment } from 'react-icons/md'
import { Class, getProfile } from '../libs/login-service'

const Wrapper = styled.div`
    display: flex;
    min-height: 100vh;
    max-width: 100vw;
    overflow-x: hidden:
    padding: 12px 32px;
`

const Heading = styled.h2`
    padding: 12px 32px;
    font-style: italic;
    color: #31c690;
`

const Ul = styled.ul`
    list-style-type: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 40px;
    flex: 1;
`

const Li = styled.li`
    padding: 12px 0;
`

const Item = styled(Link)<{ isSelected: boolean }>`
    text-decoration: none;
    padding: 10px;
    display: flex;
    align-items: center;
    gap: 10px;
    color: #717171;
    background-color: ${({ isSelected }) =>
        isSelected ? '#1D2129' : 'transparent'};
    color: ${({ isSelected }) => (isSelected ? '#ffffff' : '#717171')};
    border-radius: 50px;
`

const Body = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    border-radius: 8px;
    padding: 12px 32px;
    background-color: #f5f5f5;
`

const HeaderWrapper = styled.div`
    width: 100%;
    background-color: #ffffff;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
`

const Header = styled.div`
    padding: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`

const UserInfo = styled.div<{ profileSelected: boolean }>`
    display: flex;
    align-items: center;
    gap: 10px;
    background-color: ${({ profileSelected }) =>
        profileSelected ? '#1D2129' : 'transparent'};
    color: ${({ profileSelected }) =>
        profileSelected ? '#ffffff' : '#717171'};
    padding: 4px 8px;
    border-radius: 50px;
`
const HeadIcon = styled.img`
    width: 35px;
    height: 35px;
    border-radius: 50%;
`

const UserMenu = styled.div`
    position: absolute;
    border: 1px solid black;
    padding: 10px 20px;
    right: 50px;
    top: 100px;
`

interface Prop {
    title: string
    setIsLoggedIn: React.Dispatch<React.SetStateAction<boolean>>
    setClasses: React.Dispatch<React.SetStateAction<Class[]>>
}

const Layout = ({ title, setIsLoggedIn, setClasses }: Prop) => {
    const [profileSelected, setProfileSelected] = useState(false)
    const navigate = useNavigate()
    const [username, setUsernmae] = useState('Default User Name')

    useEffect(() => {
        const fetchProfile = async (userId: number) => {
            try {
                const profile = await getProfile(userId)
                setUsernmae(`${profile.first_name} ${profile.last_name}`)
                setClasses(profile.classes)
            } catch {
                localStorage.removeItem('userId')
                localStorage.removeItem('token')
                setIsLoggedIn(false)
                navigate('/login')
            }
        }

        const userIdJson = localStorage.getItem('userId')

        if (userIdJson) {
            const userId = JSON.parse(userIdJson)
            fetchProfile(userId)
            setIsLoggedIn(true)
        } else {
            navigate('/login')
        }
    }, [])

    // Watch for logout by monitoring localStorage
    useEffect(() => {
        const handleStorageChange = () => {
            const userIdJson = localStorage.getItem('userId')
            if (!userIdJson) {
                navigate('/login')
                setIsLoggedIn(false)
            }
        }

        window.addEventListener('storage', handleStorageChange)
        return () => window.removeEventListener('storage', handleStorageChange)
    }, [])

    function logout() {
        localStorage.removeItem('userId')
        setIsLoggedIn(false)
        navigate('/login')
    }

    return (
        <Wrapper>
            <Body>
                <HeaderWrapper>
                    <Header>
                        <Heading>Moving the Next Gen</Heading>
                        <Ul>
                            <Li>
                                <Item
                                    to="/"
                                    isSelected={title === 'Get Started'}
                                >
                                    <RiLayoutMasonryFill />
                                    Get Started
                                </Item>
                            </Li>
                            <Li>
                                <Item
                                    to="/assessment"
                                    isSelected={
                                        title === 'Movement Skill Assessment'
                                    }
                                >
                                    <FaRunning />
                                    Assessment
                                </Item>
                            </Li>
                            <Li>
                                <Item
                                    to="/report"
                                    isSelected={title === 'Report'}
                                >
                                    <MdOutlineAssessment />
                                    Report
                                </Item>
                            </Li>
                            <Li>
                                <Item
                                    to="/education"
                                    isSelected={title === 'Education'}
                                >
                                    <GiGraduateCap />
                                    Education
                                </Item>
                            </Li>
                            <Li>
                                <Item
                                    to="/aboutus"
                                    isSelected={title === 'About Us'}
                                >
                                    <RiUserSmileLine />
                                    About Us
                                </Item>
                            </Li>
                        </Ul>

                        <Item to="/profile" isSelected={title === 'Profile'}>
                            <HeadIcon src="/profile.webp" />
                            {username}
                        </Item>
                    </Header>
                </HeaderWrapper>
                <Outlet />
            </Body>
        </Wrapper>
    )
}

export default Layout
